<template>
  <div>
    <card>
      <div class="card-header-custom">
        <button type="submit" class="btn btn-fill btn-primary"
          @click="$router.push('/suppliers/create')"
        >
          <i class="fa fa-plus"></i> Hinzufügen
        </button>
      </div>
      <table-filter v-model="tableFilter" />
      <div class="row">
        <div class="col-sm-6">
          <div class="form-group">
            <multiselect v-model="category"
              :options="supplierCategories"
              track-by="id"
              label="name"
              placeholder="Nach Kategorie filtern..."
            />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-6">
          <div class="form-group">
            <multiselect v-model="tags"
              :options="supplierTags"
              track-by="id"
              label="name"
              :multiple="true"
              placeholder="Nach Tags filtern..."
            />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <transition name="el-fade-in-linear">
            <table class="table table-striped table-bordered" v-if="suppliers.length">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Kategorie</th>
                  <th>Mindestbestellwert</th>
                  <th>Letzte Bestellung</th>
                  <th class="text-center">Kommentar</th>
                  <th class="text-center">Produkte</th>
                  <th class="text-center">Bestellungen</th>
                  <th>Summe</th>
                  <th>Summe letzten 12 Monate</th>
                  <th>&nbsp;</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="supplier in filteredData" :key="supplier.id">
                  <td>
                    <router-link :to="`/suppliers/${supplier.id}`"
                    >
                      {{ supplier.name }}
                    </router-link>
                  </td>
                  <td>{{ supplier.category ? supplier.category.name : '' }}</td>
                  <td class="text-right">{{ supplier.min_order_sum | priceFromCentZeroEuro }}</td>
                  <td>{{ supplier.last_orders.length ? supplier.last_orders[0].created_at : '' | date }}</td>
                  <td class="text-center" v-tooltip.top-center="supplier.comment">
                    <i class="fa fa-comment" v-if="supplier.comment"></i>
                  </td>
                  <td class="text-center">
                    <a v-tooltip.top-center="'Produkte'" class="btn btn-warning btn-link btn-xs"
                      @click="$router.push(`/suppliers/${supplier.id}/products`)"
                    >
                      <i class="fas fa-tshirt" aria-hidden="true"></i>
                    </a>
                  </td>
                  <td class="text-center">
                    <a v-tooltip.top-center="'Bestellungen'" class="btn btn-warning btn-link btn-xs"
                      @click="$router.push(`/orders?supplier=${supplier.id}`)"
                    >
                      <i class="fas fa-shopping-cart" aria-hidden="true"></i>
                    </a>
                  </td>
                  <td class="text-right">{{ supplier.sum | priceFromCentEuro }}</td>
                  <td class="text-right">{{ getLastOrdersSum(supplier.last_orders) | priceFromCentEuro }}</td>
                  <td class="text-right">
                    <div class="td-actions">
                      <a v-tooltip.top-center="'Bearbeiten'" class="btn btn-warning btn-link btn-xs"
                         @click="editSupplier(supplier)">
                        <i class="fa fa-edit"></i>
                      </a>
                      <a v-tooltip.top-center="'Löschen'" class="btn btn-danger btn-link btn-xs"
                         @click="deleteSupplier(supplier)">
                        <i class="fa fa-close"></i>
                      </a>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </transition>
        </div>
      </div>
    </card>
    <contact-people-dialog
      :show="showContactPeople"
      :contact-people="contactPeopleToShow"
      :supplier="selectedSupplier"
      @close="showContactPeople = false"
    />
  </div>
</template>

<script>
import TableFilter from './../../components/table-filter'
import canFilterTable from './../../can-filter-table'
import ContactPeopleDialog from './contact-people-dialog'

export default {
  components: { TableFilter, ContactPeopleDialog },
  mixins: [canFilterTable],
  data () {
    return {
      suppliers: [],
      showContactPeople: false,
      selectedSupplier: null,
      contactPeopleToShow: [],
      supplierCategories: [],
      category: null,
      tags: [],
      supplierTags: []
    }
  },
  methods: {
    editSupplier (supplier) {
      this.$router.push(`/suppliers/${supplier.id}/edit`)
    },
    async deleteSupplier (supplier) {
      if (confirm(`Lieferant ${supplier.name} wirklich löschen?`)) {
        await this.initCsrf()

        this.$http.delete(`/suppliers/${supplier.id}`).then(({ data }) => {
          this.$notify({
            message: `Lieferant ${data.name} erfolgreich gelöscht.`,
            type: 'success'
          })
          const index = this.suppliers.findIndex(({ id }) => data.id === id)
          this.suppliers.splice(index, 1)
        })
      }
    },
    openContactPeople (supplier) {
      this.$http.get(`/suppliers/${supplier.id}/contact_people`).then(({ data }) => {
        this.selectedSupplier = supplier
        this.contactPeopleToShow = data
        this.showContactPeople = true
      })
    },
    getLastOrdersSum (orders) {
      return orders.reduce((sum, order) => {
        return order.products.length ? sum + +order.products[0].sum : sum
      }, 0)
    }
  },
  computed: {
    getDataToFilter () {
      const tags = this.tags.map(tag => tag.id)

      return this.suppliers.filter(supplier => {
        let hasCategory = true
        let hasTags = true

        if (this.category) {
          hasCategory = supplier.supplier_category_id === this.category.id
        }

        // TODO: some or every
        if (this.tags.length) {
          hasTags = supplier.tags.some(({ id }) => tags.includes(id))
        }

        return hasCategory && hasTags
      })
    }
  },
  created () {
    this.$http.get('/suppliers').then(({ data }) => { this.suppliers = data })
    this.$http.get('/supplier_tags').then(({ data }) => { this.supplierTags = data })
    this.$http.get('/supplier_categories').then(({ data }) => { this.supplierCategories = data })
  }
}
</script>
